import { render, staticRenderFns } from "./ProfileRouting.vue?vue&type=template&id=35a7996a&"
import script from "./ProfileRouting.vue?vue&type=script&lang=js&"
export * from "./ProfileRouting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports